export const pathRulesMain = "main";

